export default __webpack_public_path__ + "static/media/check.8ab282fe.svg";